import { React } from "react";
import GridTable from "@nadavshaar/react-grid-table";
import { BsPencilFill } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { inPlaceSort } from "fast-sort";
import ReactImageFallback from "react-image-fallback";
import companyFallback from "../../assets/images/company_fallback_img.jpg";
import darkLoader from "../../assets/images/dark_loader.gif";
import { formatDateBR } from "../../core/utils/contractStatus";
import { isMobile } from "react-device-detect";

const CompanyScreen = ({ data, onRemove, user }) => {
  let history = useHistory();

  inPlaceSort(data).by("name");

  // Verifica se é superadmin
  const isSuperAdmin = !!user?.isSuperAdmin;

  // Adiciona campo de texto do status para o filtro funcionar (apenas para superadmin)
  const rowsWithStatusText = data.map((company) => ({
    ...company,
    contractStatusText: company?.contractStatus?.status || "Sem Contrato",
  }));

  return (
    <div className="company-container">
      <div className={`company-body default-table company-list-gridtable ${isSuperAdmin ? 'with-contract-status' : 'without-contract-status'}`}>
        <GridTable
          columns={columns(onRemove, user, history, isSuperAdmin)}
          rows={rowsWithStatusText}
          canReorder={false}
          enableColumnsReorder={false}
          showSearch={true}
          isPaginated={false}
          showColumnVisibilityManager={false}
          showRowsInformation={false}
          texts={{
            noResults: "Nenhum resultado foi encontrado",
            search: "Buscar:",
            totalRows: "Número de itens:",
            rows: "Itens:",
            selected: "Selecionado",
            rowsPerPage: "Itens por página:",
            page: "Página:",
            of: "de",
            prev: "Anterior",
            next: "Próximo",
            columnVisibility: "Colunas visíveis",
          }}
        />
      </div>
    </div>
  );
};

export default CompanyScreen;

const columns = (onRemove, user, history, isSuperAdmin) => {
  const baseColumns = [
    {
      id: 3,
      field: "logo",
      label: "",
      width: "50px",
      resizable: true,
      cellRenderer: ({ data }) => {
        return (
          <div className="image-cell">
            <div className="image-container">
              <ReactImageFallback
                src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${data.logo}`}
                fallbackImage={companyFallback}
                initialImage={darkLoader}
                alt=""
                className="my-image"
              />
            </div>
          </div>
        );
      },
    },
    {
      id: 1,
      field: "name",
      label: "Nome",
      width: "1fr",
      resizable: false,
      cellRenderer: ({ data }) => <NameCell data={data} history={history} isSuperAdmin={isSuperAdmin} />,
    },
  ];

  // Apenas superadmins veem a coluna de status do contrato
  if (isSuperAdmin) {
    baseColumns.push({
      id: 4,
      field: "contractStatusText", // Campo de texto para filtro
      label: "Status do Contrato",
      width: "250px",
      resizable: false,
      visible: !isMobile, // Esconde completamente a coluna no mobile
      cellRenderer: ({ data }) => <ContractStatusCell data={data} />,
    });
  }

  baseColumns.push({
    id: 2,
    field: "actions",
    label: "Ações",
    resizable: false,
    width: "70px",
    cellRenderer: ({ data }) => (
      <ActionCell
        data={data}
        onRemove={onRemove}
        user={user}
        history={history}
      />
    ),
  });

  return baseColumns;
};

const NameCell = ({ data, history, isSuperAdmin }) => {
  const hasContractStatus = isSuperAdmin && data.contractStatus && data.contractStatus.status;

  return (
    <div
      className="company-name-cell"
      onClick={() => history.push(`/company/details/${data.id}`, data)}
    >
      <div className="clickable-name">{data.name}</div>
      {hasContractStatus && (
        <div className="contract-status-mobile">
          <div className={`contract-status-badge ${data.contractStatus.className}`}>
            <span className="status-icon">{data.contractStatus.icon}</span>
            <span>{data.contractStatus.status}</span>
          </div>
        </div>
      )}
    </div>
  );
};

const ContractStatusCell = ({ data }) => {
  if (!data.contractStatus) {
    return (
      <div className="contract-status-cell">
        <span className="contract-description">-</span>
      </div>
    );
  }

  const { status, className, icon, description, expirationDate } = data.contractStatus;

  return (
    <div className="contract-status-cell">
      <div className={`contract-status-badge ${className}`}>
        <span className="status-icon">{icon}</span>
        <span>{status}</span>
      </div>
      {description && (
        <span className="contract-description">{description}</span>
      )}
      {expirationDate && (
        <span className="contract-description">
          Vencimento: {formatDateBR(expirationDate)}
        </span>
      )}
    </div>
  );
};

const ActionCell = ({ data, history }) => {
  return (
    <div className="field-actions">
      <BsPencilFill
        className="icon-action edit"
        onClick={() => history.push(`/company/details/${data.id}`, data)}
      />
      {/* {user && [1, 2].includes(user.id) && <BsTrashFill className='icon-action trash' onClick={() => onRemove(data)} />} */}
    </div>
  );
};
